/**
 * Wishlist Hero escanea los botones en la carga inicial. El contenido que llega después
 * (product-tabs clona desde <template>, infinite scroll, etc.) debe notificarse con
 * wishlist-hero-add-to-custom-element (documentación Wishlist Hero / integraciones Boost).
 */
(() => {
  if (window.__wimWishlistHeroDyn) return;
  window.__wimWishlistHeroDyn = true;

  const isWlhHost = (el) =>
    el instanceof HTMLElement &&
    el.classList.contains('wishlist-hero-custom-button') &&
    !el.querySelector('button');

  const notifyHost = (el) => {
    if (!isWlhHost(el)) return;
    document.dispatchEvent(
      new CustomEvent('wishlist-hero-add-to-custom-element', {
        detail: el,
      })
    );
  };

  const scanRoot = (root) => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    if (isWlhHost(root)) notifyHost(root);
    root.querySelectorAll?.('.wishlist-hero-custom-button').forEach((node) => {
      if (isWlhHost(node)) notifyHost(node);
    });
  };

  document.addEventListener('tabChange', (e) => {
    const tab = e.detail?.selectedTab;
    if (!tab) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => scanRoot(tab));
    });
  });

  const subtreeMayHaveWlh = (el) =>
    el instanceof HTMLElement &&
    (isWlhHost(el) || el.querySelector?.('.wishlist-hero-custom-button'));

  const mo = new MutationObserver((mutations) => {
    const roots = [];
    for (const m of mutations) {
      if (m.type !== 'childList' || !m.addedNodes.length) continue;
      for (const n of m.addedNodes) {
        if (n.nodeType === Node.ELEMENT_NODE && subtreeMayHaveWlh(n)) roots.push(n);
      }
    }
    if (!roots.length) return;
    requestAnimationFrame(() => {
      roots.forEach((n) => scanRoot(n));
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

(() => {
  if (!window.__wimWishlistHeroLocaleFixEnabled) return;
  if (window.__wimWishlistHeroLocaleFix) return;
  window.__wimWishlistHeroLocaleFix = true;

  const root = (window.Shopify?.routes?.root) || '/';
  const localePrefix = root.replace(/\/$/, '');

  if (!localePrefix) return;

  const origin = window.location.origin;
  const pathRe = /\/(products|collections)\//;

  const isWlhScope = (el) =>
    el?.closest?.('[class*="wishlist-hero"], [id*="wishlist-hero"], [id*="hero-wishlist"]');

  const fixedPath = (href) => {
    if (!href) return null;
    // Relative: /products/... or /collections/...
    if (pathRe.test(href) && href.startsWith('/') && !href.startsWith(localePrefix + '/')) {
      return localePrefix + href;
    }
    // Absolute same-origin: https://domain/products/... (without locale)
    if (href.startsWith(origin + '/')) {
      const path = href.slice(origin.length);
      if (pathRe.test(path) && !path.startsWith(localePrefix + '/')) {
        return origin + localePrefix + path;
      }
    }
    return null;
  };

  const fixLink = (a) => {
    if (!(a instanceof HTMLAnchorElement)) return;
    if (!isWlhScope(a)) return;
    const fixed = fixedPath(a.getAttribute('href'));
    if (fixed) a.setAttribute('href', fixed);
  };

  const scan = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.tagName === 'A') fixLink(node);
    node.querySelectorAll?.('a').forEach(fixLink);
  };

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList' || !m.addedNodes.length) continue;
      m.addedNodes.forEach((n) => n.nodeType === Node.ELEMENT_NODE && scan(n));
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    const a = e.target.closest?.('a');
    if (!a || !isWlhScope(a)) return;
    const fixed = fixedPath(a.getAttribute('href'));
    if (fixed) {
      e.preventDefault();
      window.location.href = fixed;
    }
  }, true);
})();
